import { ButtonHTMLAttributes, JSX, ReactNode } from "react";

import { cn } from "@/utils/cn.ts";

interface CircleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  buttonType: "entrance" | "white" | "exet" | "social media";
  className?: string;
  text?: string;
}

const CircleButton = ({
  icon,
  buttonType = "entrance",
  className,
  text,
  ...otherProps
}: CircleButtonProps): JSX.Element => {
  return (
    <button
      type={otherProps.type ? otherProps.type : "button"}
      {...otherProps}
      className={cn(
        "group rounded-full outline outline-1 -outline-offset-1 outline-transparent transition-all focus:outline-on-primary [&>svg]:size-6",
        {
          "bg-surface-container-low p-4 outline-surface-bright hover:bg-surface-container-high active:bg-surface-container-high active:outline-on-primary [&>svg]:size-8":
            buttonType === "entrance",
          "bg-gradient-2 p-5 hover:bg-on-primary active:bg-on-primary [&>svg]:stroke-on-primary active:[&>svg]:stroke-orange-1 group-hover:[&>svg]:stroke-orange-1":
            buttonType === "white",
          "bg-surface-container-low p-4 hover:bg-surface-container-high active:bg-surface-container-high max-lg:p-3 [&>svg]:stroke-on-primary":
            buttonType === "exet",
          "bg-surface-container p-[0.625rem] outline-surface-container hover:bg-surface-container-high [&>svg]:fill-on-primary":
            buttonType === "social media",
          "flex items-center gap-[0.625rem]": text,
        },
        className,
      )}
    >
      {!text ? (
        icon
      ) : (
        <>
          {icon}
          <span className={"hidden text-sm font-semibold leading-[0.938rem] text-on-primary max-lg:inline"}>
            {text}
          </span>
        </>
      )}
    </button>
  );
};

export default CircleButton;
